module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA6BAMAAAAeiydcAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAASUExURUdwTFy+e1y/e12+fF2+e12+fFdFSo8AAAAFdFJOUwB/Rr/P7aYqXwAAALNJREFUOMvdlDEOgzAMReNW7KhSdjr0Hl26E6F//6uUFNrYH2IJqR1ST4mfHoFgO4SvxHUo69OFqSCVTURPuAPKBhgbwGc4cQ8PD08BbvwzHmsF1DWIBxdLcvHaBhUsWFqmgqOLZ9l7+Fvexx/ZYulJtjgmkg2WNVtkg29LWsls57yS6ewMtExvnomW6btnNGmZsLxKN1XLIcLIjMXKmzuPRt5gMzl3/pieu2020QH8u8n0BENU4kQGpxmYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notification/booking_complete.png
// module id = 1812
// module chunks = 0